import { Injectable } from '@angular/core';
import { ActionReducerMap } from '@ngrx/store';
import { UI_REDUCER } from '@safarilaw-webapp/shared/redux';
import { SafariRouterReduxObject } from '../router/redux/state';
import { IRouterFeatureState, SafariInjector } from '@safarilaw-webapp/shared/common-objects-models';

@Injectable({
  providedIn: 'root'
})
export class RouterReducerService extends SafariInjector {
  private _routerReduxObject: SafariRouterReduxObject;
  constructor() {
    super();
    this._routerReduxObject = this.inject(SafariRouterReduxObject);
  }
  get reducers() {
    const reducers: ActionReducerMap<IRouterFeatureState> = {
      routerState: UI_REDUCER(this._routerReduxObject)
    };
    return reducers;
  }
}
